export default "__VITE_ASSET__CztPCXmE__"